import {appConfig} from '../config'

export const experiments = {
  isBusinessToggleVisible: Boolean(appConfig.experiments3?.delivery_frontend_order_business_toggle_visibility?.enabled),
}
